export const QUALIFYING_LEVEL_REQUIREMENT_HEADING = "Qualifying Level Requirement";

export const QUALIFYING_LEVEL_REQUIREMENT_BODY =
  "Official background check status for qualifying level membership. The cards below show status, screened date, and expiration from the membership record.";

export const SCREENING_ORDERS_HEADING = "Screening Orders";

export const SCREENING_ORDERS_BODY =
  "HireRight screening orders used to collect background check information. Use this table to review order status, provider activity, and send invitations.";

export const NEW_SCREENING_ORDER_LABEL = "New Screening Order";

export const NEW_ORDER_LABEL = "New Order";

export const EDIT_BACKGROUND_CHECK_LABEL = "Edit Background Check";

export const CREATE_ORDER_DIALOG_HEADLINE = NEW_SCREENING_ORDER_LABEL;

export const SEND_INVITATION_DIALOG_HEADLINE = "Send Invitation";

export const SCREENING_ORDERS_EMPTY_APPROVED =
  "This person's qualifying level background check is approved. Create a screening order only if you need to start a new cycle or send an invitation email.";

export const SCREENING_ORDERS_EMPTY_DEFAULT = "No HireRight screening orders have been created for this person.";

export const SCREENING_ORDERS_LOAD_ERROR_TITLE = "Unable to load screening orders";

export const SCREENING_ORDERS_LOAD_ERROR_CAPTION = "Screening order history could not be loaded.";

export const FOCUSED_PAGE_LOAD_ERROR = "Background check details could not be loaded.";
